import React from "react";
import { FiTwitter, FiLinkedin, FiGlobe } from "react-icons/fi";

export default function AuthorBio({ author }) {
  if (!author) return null;

  return (
    <div className="mt-12 p-6 bg-light-gray/5 rounded-lg border border-stroke">
      <div className="flex items-start gap-4">
        {author.avatar && (
          <img
            src={author.avatar}
            alt={author.name}
            className="w-20 h-20 rounded-full flex-shrink-0"
          />
        )}
        <div className="flex-grow">
          <h3 className="text-20 font-medium text-secondary mb-1">
            {author.name}
          </h3>
          {author.credentials && (
            <p className="text-12 text-primary mb-2">{author.credentials}</p>
          )}
          {author.bio && (
            <p className="text-14 text-light-gray mb-3">{author.bio}</p>
          )}
          {/* Social Links */}
          {(author.twitter || author.linkedin || author.website) && (
            <div className="flex items-center gap-3">
              {author.twitter && (
                <a
                  href={author.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light-gray hover:text-primary transition-colors"
                  aria-label="Twitter"
                >
                  <FiTwitter className="w-5 h-5" />
                </a>
              )}
              {author.linkedin && (
                <a
                  href={author.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light-gray hover:text-primary transition-colors"
                  aria-label="LinkedIn"
                >
                  <FiLinkedin className="w-5 h-5" />
                </a>
              )}
              {author.website && (
                <a
                  href={author.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light-gray hover:text-primary transition-colors"
                  aria-label="Website"
                >
                  <FiGlobe className="w-5 h-5" />
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
